(() => {
  if (customElements.get('playtime-first-order')) return;
  class FirstOrder extends HTMLElement {
    connectedCallback() {
      if (this.lifecycle || typeof HTMLDialogElement === 'undefined' || !HTMLDialogElement.prototype.showModal) return;
      const details = this.querySelector('details'), trigger = details?.querySelector('summary'), panel = this.querySelector('[data-offer-panel]');
      if (!trigger || !panel) return;
      this.lifecycle = new AbortController();
      const options = { signal:this.lifecycle.signal };
      const dialog = this.dialog = document.createElement('dialog');
      dialog.className = 'pt-offer__dialog';
      const title = panel.querySelector('h2');
      dialog.id = title.id + '-dialog';
      dialog.setAttribute('aria-labelledby',title.id);
      dialog.append(panel);
      this.append(dialog);
      details.open = false;
      trigger.setAttribute('aria-haspopup','dialog');
      trigger.setAttribute('aria-controls',dialog.id);
      trigger.setAttribute('aria-expanded','false');
      const close = panel.querySelector('[data-offer-close]');
      close.hidden = false;
      const form = panel.querySelector('form');
      const submit = panel.querySelector('[data-offer-submit]');
      const submitText = submit?.textContent;
      const accepted = panel.querySelector('[data-offer-accepted]');
      const copy = panel.querySelector('[data-offer-copy]');
      const code = accepted?.querySelector('[data-offer-code]');
      const reward = accepted?.querySelector('[data-offer-reward]');
      const status = accepted?.querySelector('[data-offer-copy-status]');
      const page = new URL(location.href);
      const returned = page.searchParams.get('pt_offer')==='return';
      if (returned) {
        page.searchParams.delete('pt_offer');
        try { window.history.replaceState(window.history.state,'',page); } catch {}
      }
      const burst = !!accepted && !matchMedia('(prefers-reduced-motion:reduce)').matches;
      if (burst) reward.hidden = true;
      const open = () => {
        if (dialog.open) return;
        dialog.showModal();
        trigger.setAttribute('aria-expanded','true');
        (code && !reward.hidden ? code : form.querySelector('input[type=email]') || close).focus({preventScroll:true});
      };
      trigger.addEventListener('click',e=>{ e.preventDefault(); open(); },options);
      close.addEventListener('click',()=>dialog.close(),options);
      dialog.addEventListener('close',()=>{
        trigger.setAttribute('aria-expanded','false');
        if (this.isConnected) trigger.focus({preventScroll:true});
      },options);
      dialog.addEventListener('click',e=>{
        if (e.target !== dialog) return;
        const box=dialog.getBoundingClientRect();
        if (e.clientX<box.left || e.clientX>box.right || e.clientY<box.top || e.clientY>box.bottom) dialog.close();
      },options);
      if (submit) {
        const enable = () => { submit.disabled=false; submit.textContent=submitText; form.removeAttribute('aria-busy'); };
        form.addEventListener('submit',event=>{
          if (event.defaultPrevented) return;
          if (submit.disabled) { event.preventDefault(); return; }
          if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); return; }
          submit.disabled=true; submit.textContent=submit.dataset.sending; form.setAttribute('aria-busy','true');
          queueMicrotask(()=>{ if (event.defaultPrevented) enable(); });
        },options);
        window.addEventListener('pageshow',enable,options);
      }
      if (copy) {
        copy.hidden = false;
        code.addEventListener('click',()=>code.select(),options);
        copy.addEventListener('click',async ()=>{
          try {
            await navigator.clipboard.writeText(code.value);
            status.textContent=status.dataset.copied;
          } catch {
            code.focus({preventScroll:true}); code.select();
            status.textContent=status.dataset.manual;
          }
        },options);
      }
      const receiptUnknown = returned && !accepted && panel.querySelector('[data-offer-unconfirmed]');
      if (receiptUnknown) receiptUnknown.hidden=false;
      if (accepted || panel.querySelector('[data-offer-error]') || receiptUnknown) {
        open();
        if (!accepted) return;
        const reveal = () => {
          reward.hidden=false;
          status.textContent=status.dataset.ready;
          if (dialog.open && (document.activeElement===close || document.activeElement===dialog)) code.focus({preventScroll:true});
        };
        if (burst) {
          this.celebrate(panel);
          this.revealTimer=setTimeout(reveal,210);
        } else reveal();
      }
    }
    celebrate(panel) {
      const burst=document.createElement('div'); burst.className='pt-offer__confetti'; burst.setAttribute('aria-hidden','true');
      const width = panel.getBoundingClientRect().width;
      for (const side of ['left','right']) {
        const dir=side==='left'?1:-1;
        for (let i=0;i<12;i++) {
          const bit=document.createElement('i');bit.dataset.side=side;
          const distance=dir*width*(.23+((i*13)%31)/100),apex=-58-((i*19)%72),spin=dir*(82+((i*41)%155));
          const vars={'--flake':i%2?'#ECA8BC':'#D9F569','--delay':i*3+'ms','--mid-x':distance*.43+'px','--late-x':distance*.75+'px',
            '--end-x':distance+'px','--apex-y':apex+'px','--late-y':apex*.61+'px','--land-y':((i*11)%27)+'px',
            '--mid-spin':spin*.5+'deg','--spin':spin+'deg','--end-spin':spin*1.4+'deg'};
          for (const [key,value] of Object.entries(vars)) bit.style.setProperty(key,value);
          if (side==='right' && i===11) bit.addEventListener('animationend',()=>burst.remove(),{once:true});
          burst.append(bit);
        }
      }
      panel.append(burst);
    }
    disconnectedCallback() {
      if (!this.lifecycle) return;
      this.lifecycle.abort(); this.lifecycle=null;
      clearTimeout(this.revealTimer);
      this.dialog?.querySelector('.pt-offer__confetti')?.remove();
      const panel=this.dialog?.querySelector('[data-offer-panel]');
      if (panel) this.querySelector('details').append(panel);
      this.dialog?.remove(); this.dialog=null;
    }
  }
  customElements.define('playtime-first-order',FirstOrder);
})();
